import { render, staticRenderFns } from "./CertImport.vue?vue&type=template&id=33907158&scoped=true"
import script from "./CertImport.vue?vue&type=script&lang=js"
export * from "./CertImport.vue?vue&type=script&lang=js"
import style0 from "./CertImport.vue?vue&type=style&index=0&id=33907158&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33907158",
  null
  
)

export default component.exports